module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pro",
      "epub:type": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "id": "pro",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("When Jennifer Levin was killed in Central Park, sometime between five and five-thirty in the morning of August 26, 1986, the vast park was as quiet as it always was just before dawn. The occasional sounds to be heard were muted—a lone automobile on the park roadway or the footfall of an early jogger. Of the thousands of New Yorkers asleep nearby, none heard Jennifer Levin’s final gasp for breath.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But for all the silence, Jennifer Levin did not go quietly. The bruised and twisted body of the pretty eighteen-year-old was eloquent testimony to the violence of her death.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was sprawled partly nude at the base of a large American elm tree off the park’s winding East Drive, barely fifty yards behind the Metropolitan Museum of Art. She lay south to north, her arms and legs askew in all directions, her right fist tilted upward at the Manhattan sky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The scoop-necked blouse and bra were pushed up to her throat, baring untanned breasts. The pink-and-white "), _c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("skirt was hiked to her waist, with the belly and pubis exposed. Only the feet remained fully covered, in white canvas flat shoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The stark tableau, redolent of murder, was shielded from part of the East Drive by a sagging branch of the elm. Since death had occurred just before daybreak, the darkness provided even more cover.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Just one person was physically close enough to see how Jennifer Levin died. He was someone she had thought she knew very well. Too well, by some standards. Not nearly well enough, as it turned out.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Robert Chambers, nineteen, tall and handsome, had spent the last hour of Jennifer’s life with her. He would stay close to her lifeless body for another ninety minutes, possibly never more than one hundred feet away.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("An autopsy would indicate that Jennifer Levin had died of asphyxiation by strangulation, but exactly how she had been strangled remained a mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For several hours Robert Chambers denied any knowledge of or responsibility for her death, then offered detectives a strange tale of kinky sex, anger, and reflexive action. His face and body bore wounds from an apparent struggle.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Despite a sixty-five-minute videotape in which Robert Chambers claimed that his actions accidentally caused Jennifer’s death, his indictment on second-degree murder charges alleged that he intended to kill her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Chambers’ trial, beginning more than sixteen months after Jennifer Levin was killed, failed to clear up the confusion. Witnesses changed their accounts of what they had seen. The police confessed to a series of missed clues, misplaced evidence, misapplied procedures, and mistaken inferences that further clouded the case. Experts offered contradictory opinions about the causes and nature of the injuries to both "), _c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Robert and Jennifer. And the rules of evidence limited the information available to the jury about those fateful moments in the park.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Only Robert Chambers knew exactly what happened. To this day, only he knows the full truth.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The rest of the world, or the part of it that cares, knows only what emerged during his trial.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0